module.exports = __webpack_public_path__ + "img/tips1_botlist4img2.cbb345a6.jpg";